export const HERO = {
    title: "Hi, I'm",
    subtitle: "I'm a",
    name: "Zobayer Hosen",
    typeWriter: ["Front-end Developer", "Web Developer"],
    bgImage: "/Asset/hero_bg.jpg",
    button: {
        text: "My Resume",
        url: "/"
    }
}